// extracted by mini-css-extract-plugin
module.exports = {"mentionAlertChatMode":"UserMessages_mentionAlertChatMode__RAuBE","blink":"UserMessages_blink__t4-zN"};